import { CartIcon } from '../icons/CartIcon';
import { useCart } from '../../context/CartContext';
import { Link } from 'react-router-dom';

export function CartButton() {
  const { totalItems } = useCart();

  return (
    <Link
      to="/cart"
      aria-label={`View cart, ${totalItems} item${totalItems === 1 ? '' : 's'}`}
      className="relative flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-text transition-colors hover:border-white/20 hover:bg-white/5"
    >
      <CartIcon className="h-5 w-5" />
      {totalItems > 0 && (
        <span className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-accent px-1 text-[0.65rem] font-extrabold text-black">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
    </Link>
  );
}
